import { createFileRoute, redirect } from "@tanstack/react-router"
import { SegmentEditor } from "@/components/audience/segment-editor"
import { fieldsQuery, tagsQuery, workspaceQuery } from "@/lib/queries"

export const Route = createFileRoute("/w/$workspace/contacts/segments/new")({
  beforeLoad: async ({ context, params }) => {
    const ctx = await context.queryClient.ensureQueryData(workspaceQuery(params.workspace))
    if (!ctx.permissions.includes("edit_automations")) throw redirect({ to: "/w/$workspace/contacts/segments", params })
  },
  loader: ({ context, params }) => Promise.all([context.queryClient.ensureQueryData(tagsQuery(params.workspace)), context.queryClient.ensureQueryData(fieldsQuery(params.workspace))]),
  component: () => <SegmentEditor segment={null} />,
})
